<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {api, DataType} from "src/services/api/reallis"
    import {onMount} from "svelte"
    import Alert from 'src/components/main/#common/alert/Alert.svelte'
    import spinIcon from '../../../../materials/images/spin.svg'
    import {showAlert} from "src/components/main/#common/alert/store"
    import {delay, navigate} from "src/components/main/#common/helpers"
    import {isLoggedIn} from "../../../services/auth"
    import IconifyIcon from '@iconify/svelte'
    import hideIcon from '@iconify/icons-fa-solid/eye'
    import showIcon from '@iconify/icons-fa-solid/eye-slash'
    import uIcon from 'src/components/#assets/u.svg'
    import spirale from 'src/components/#assets/spirale.png'
    import elipse from 'src/components/#assets/elipse.png'

    export let hash

    let newPassword = ''
    let repeatPassword = ''
    let errorStatus = false
    let errorText = ''
    let sending = false
    let loadingIcon = '<img class="loading" src="'+spinIcon+'" alt=""/>'

    async function ForgotPass() {
        if (newPassword.length < 8 || repeatPassword.length < 8) {
            errorStatus = true;
            errorText = 'Must be at least 8 characters'
            return
        }

        if (newPassword != repeatPassword) {
            errorStatus = true;
            errorText = 'Password mismatch'
            return
        }

        try {
            sending = true
            errorStatus = false

            await api.ws.ws1.request({
                data: {
                    agent: "auth",
                    auth: {type: "webSite"},
                    lang: "en",
                    method: "auth_resetPassword",
                    params: {
                        "newPassword": newPassword,
                        "hash": hash
                    }
                }
            })

            await delay(600)

            navigate("/login")

            showAlert.set({
                status: 'success',
                text: 'Your Password has been Changed'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            sending = false
        }
    }

    let showNewPassword = false
    let showRepeatPassword = false

    function showHideNewPassword() {
        showNewPassword = !showNewPassword
    }

    function showHideRepeatPassword() {
        showRepeatPassword = !showRepeatPassword
    }

    $: if ($isLoggedIn) {
        // navigate("/account")

        // If the user is authorized but has forgotten the password, it is necessary to logout and give set a new password
        api.ws.ws1.auth.logout()
    }
</script>

<svelte:head>
    <title>Reset Password</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="panel-wrapper">
            <div class="container">
                <div class="auth-background"></div>
                <div class="auth-wrapper">
                    <img src="{elipse}" class="elipse" alt="">
                    <img src="{spirale}" class="spirale" alt="">
                    <img src="{uIcon}" class="u-icon" alt="">
                    <form on:submit|preventDefault={ForgotPass} novalidate>
                        <Alert />
                        <h1 class="title">Reset Password</h1>
                        <div class="input-group">
                            <div class="position-relative w-100">
                                {#if showNewPassword === true}
                                    <input type="text" class="form-control field" placeholder="Enter new password"
                                        bind:value={newPassword} autocomplete="none" autofocus>
                                {:else}
                                    <input type="password" class="form-control field" placeholder="Enter new password"
                                        bind:value={newPassword} autocomplete="none" autofocus>
                                {/if}
                                <button type="button" class="show-hide-password" on:click={showHideNewPassword}>
                                    <IconifyIcon icon={showNewPassword ? showIcon : hideIcon}/>
                                </button>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="position-relative w-100">
                                {#if showRepeatPassword === true}
                                    <input type="text" class="form-control field" placeholder="Repeat new password"
                                        bind:value={repeatPassword} autocomplete="none">
                                {:else}
                                    <input type="password" class="form-control field" placeholder="Repeat new password"
                                        bind:value={repeatPassword} autocomplete="none">
                                {/if}
                                <button type="button" class="show-hide-password" on:click={showHideRepeatPassword}>
                                    <IconifyIcon icon={showRepeatPassword ? showIcon : hideIcon}/>
                                </button>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                            <button type="submit" class="btn btn-primary auth-button" class:loading={sending}
                                disabled={sending}><span>Reset</span></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .container {
        position: relative;
    }

    .auth-background {
        background: linear-gradient(220deg, rgba(44, 43, 64, 0.15) 23%, #1E1920 50%);
        filter: blur(200px);
        width: calc(100% - 24px);
        height: 550px;
        position: absolute;
    }

    .auth-wrapper {
        background: #27232C;
        border-radius: 10px;
        border: 2px solid #7B7DB3;
        max-width: 480px;
        margin: 60px auto 150px;
        padding: 40px;
        z-index: 2;
        position: relative;
    }

    .auth-wrapper .form-control {
        border: 1px solid #7B7DB3;
        border-radius: 3px;
        box-shadow: none !important;
    }

    .auth-button {
        width: 100%;
        margin-top: 20px;
        padding: 17px 45px !important;
        font-weight: 500;
    }

    .title {
        position: relative;
        text-align: center;
        color: white;
        line-height: 30px;
        margin: 10px 0 50px;
        font-size: 30px;
    }

    .input-group {
        max-width: 550px;
        margin: 10px auto;
    }

    label {
        max-width: 600px;
        float: left;
        margin: 5px 0;
        color: white;
        font-size: 15px;
        line-height: 30px;
        position: relative;
        bottom: 50px;
    }

    input {
        margin: 5px 0;
    }

    a {
        color: white;
        text-decoration: underline;
        position: center;
    }

    input {
        margin: 5px 0;
    }

    .auth-wrapper :global(.alert) {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: left;
        padding: 15px 45px 15px 15px;
    }

    .show-hide-password {
        position: absolute;
        background: none;
        right: 1px;
        top: 6px;
        height: 48px;
        width: 48px;
        color: #464957;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        z-index: 2;
    }

    .elipse {
        position: absolute;
        z-index: 2;
        left: -289px;
        top: -63px;
        -webkit-user-drag: none;
    }

    .spirale {
        position: absolute;
        z-index: 2;
        right: -320px;
        top: 180px;
        -webkit-user-drag: none;
    }

    .u-icon {
        position: absolute;
        z-index: 2;
        top: 310px;
        left: -180px;
        -webkit-user-drag: none;
    }

    @media(max-width: 1400px) {
        .spirale {
            right: -250px;
        }
    }

    @media(max-width: 991px) {
        .spirale {
            right: -130px;
        }
    }

    @media(max-width: 767px) {
        .title {
            line-height: 20px;
            margin: 0 0 30px;
            font-size: 20px;
        }

        .form-control.field {
            padding: 10px;
            font-size: 16px;
        }

        .show-hide-password {
            height: 39px;
            width: 39px;
            top: 1px;
        }

        .spirale,
        .elipse,
        .u-icon {
            display: none;
        }

        .auth-wrapper {
            margin: 20px auto -20px;
            padding: 30px;
        }

        .auth-wrapper .form-control {
            padding: 8px 20px;
            font-size: 16px;
            margin: 0;
        }

        .auth-button {
            padding: 12px 15px !important;
            margin-top: 10px;
        }

        .auth-background {
            height: auto;
        }
    }
</style>
